<template>
  <div class="loading">
    <!-- //加载页 -->
    <div class="loading_outer">
      <div class="loading_box">
        <div class="loading_point loading_point_one"></div>
        <div class="loading_point loading_point_two"></div>
        <div class="loading_point loading_point_three"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: {
    // msg: String
  }
};
</script>
<style lang="less" scoped>
/* 首屏加载动画 */
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
}
.loading_box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
}

.loading_box .loading_point {
  width: 0.6rem;
  height: 0.6rem;
  background-color: #ea5514;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
  animation: bouncedelay 1.4s infinite ease-in-out;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.loading_box .loading_point_one {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.loading_box .loading_point_two {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  40% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
</style>
